var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLead = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_account_circle_24px",
    d: "M9,2a7,7,0,1,0,7,7A7,7,0,0,0,9,2ZM9,4.1A2.1,2.1,0,1,1,6.9,6.2,2.1,2.1,0,0,1,9,4.1Zm0,9.94a5.04,5.04,0,0,1-4.2-2.254C4.821,10.393,7.6,9.63,9,9.63s4.179.763,4.2,2.156A5.04,5.04,0,0,1,9,14.04Z",
    transform: "translate(-2 -2)",
    fill: "#727272"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLead);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-lead.7432fb170501997ec1fb77e03157b878.svg";